<p-toast></p-toast>
<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="empresa" style="font-family: system-ui;">Empresa</label>
                <p-dropdown class="p-inputtext-sm" [options]="empresas" [(ngModel)]="selecionarEmpresa"
                    [showClear]="true" optionLabel="nome_fantasia" placeholder="Selecione a Empresa"></p-dropdown>
            </div>
        </div>
        <!-- <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="selecionarOrigem" style="font-family: system-ui;">Origem</label>
                <p-dropdown class="p-inputtext-sm" [options]="origens" [(ngModel)]="selecionarOrigem"
                    optionLabel="nome"></p-dropdown>
            </div>
        </div> -->
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-6 p-lg-4">
                <label for="selecionarPeriodo" style="font-family: system-ui;">Período</label>
                <p-dropdown class="p-inputtext-sm" [options]="periodos" [(ngModel)]="selecionarPeriodo"
                    optionLabel="nome" optionValue="nome" (onChange)="onChangePeriodo($event)"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Inicial</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Final</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-2" style="align-self: flex-end;">
                <button style="height: 39.272px; background-color: rgb(167, 32, 8);" pButton pRipple type="button"
                    label="Pesquisar" class="p-button-raised" (click)="pesquisar()"></button>
            </div>
        </div>
        <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-7">
                <p-table #dt [value]="lista" selectionMode="single" [(selection)]="selectedList"
                    styleClass="p-datatable-sm p-datatable-striped" dataKey="origem" [scrollable]="true"
                    scrollHeight="300px" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 300px;">Origem</th>
                            <th style="width: 90px; text-align: right;">Valor</th>
                            <th style="width: 90px;text-align: right;">%</th>
                            <th style="width: 90px;text-align: right;">Parcelas</th>
                            <th style="width: 90px;text-align: right;">%</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-cliente>
                        <tr [pSelectableRow]="cliente">
                            <td style="width: 300px;"><b>{{cliente.origem}}</b></td>
                            <td style="width: 90px;text-align: right;">{{cliente.valor}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.perc_valor}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.parcela}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.perc_parcelas}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-6 p-lg-5">
                <p-chart type="pie" [data]="grafico"></p-chart>
            </div>
        </div>

        <!-- <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-12">
                <p-chart type="polarArea" [data]="grafico_bar"></p-chart>
            </div>
        </div> -->
    </div>
</p-card>

<!-- ORÇAMENTOS -->
<p-dialog header="B - Orçamentos" [(visible)]="displayOrcamento" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaOrcamento" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.valor_nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela |
                    currency:'BRL':true}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalOrcamento}}</b></span>
            <p-button icon="pi pi-check" (click)="displayOrcamento=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM ORÇAMENTOS -->

<!-- SERVIÇOS DE CONSERVAÇÃO -->
<p-dialog header="C - Serviços de Conservação" [(visible)]="displayServicoConservacao" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaServicoConservacao" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.valor_nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela |
                    currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalServicoConservacao}}</b></span>
            <p-button icon="pi pi-check" (click)="displayServicoConservacao=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM SERVIÇOS DE CONSERVAÇÃO -->

<!-- SERVIÇOS -->
<!-- <p-dialog header="E - Serviços" [(visible)]="displayServico" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaServico" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.valor_nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela |
                    currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}
                </td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date:
                    'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>
    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalServico}}</b></span>
            <p-button icon="pi pi-check" (click)="displayServico=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog> -->
<!-- FIM SERVIÇOS -->

<!-- VENDA -->
<!-- <p-dialog header="F - Venda" [(visible)]="displayVenda" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaVenda" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela |
                    currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}
                </td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date:
                    'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVenda}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVenda=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog> -->
<!-- FIM VENDA -->